let previousSlide;
let slideHeightAdjuster = () => {
  if (previousSlide) previousSlide.removeAttribute('height')
  if (window.innerWidth < 1025) return
  let current_slide = document.querySelectorAll(".testimonial-slider .slider-wrap .slick-active .col-8 .text-wrap")[0]
  previousSlide = document.querySelectorAll(".testimonial-slider .slider-wrap .slick-active .col-8 .text-wrap")[0]
  let next_slide = document.querySelectorAll(".testimonial-slider .slider-wrap .slick-active .col-8 .text-wrap")[1]
  current_slide.clientHeight > next_slide.clientHeight ? 0 : current_slide.setAttribute("style", `height:${next_slide.clientHeight + 20}px`);
}

(function ($) {
  $(document).ready(function () {
    if ($(".testimonial-slider ").length > 0) {
      setTimeout(function () {
        $(".testimonial-slider .row-wrap .slider-wrap").css({opacity: "1"});
      }, 500);
      if ($(".testimonial-slider .row-wrap .slider-wrap .card").length > 2) {
        $(".testimonial-slider .row-wrap .slider-wrap .card").css({'width': "650px"});
        $(".testimonial-slider .row-wrap .slider-wrap").slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          asNavFor: '.testimonial-slider .bg-img',
          responsive: [
            {
              breakpoint: 1451,
              settings: {
                slidesToShow: 2,
                draggable: true,
              },
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 1,
                draggable: true,
              },
            },
            {
              breakpoint: 595,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
        $(".testimonial-slider .bg-img").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: true,
          asNavFor: '.testimonial-slider .row-wrap .slider-wrap',
          focusOnSelect: true,
          fade: true,
        })
        let arrows = document.querySelectorAll(".testimonial-slider .slider-wrap .slick-arrow")
        slideHeightAdjuster()
        arrows.forEach((arrow) => {
          arrow.addEventListener("click", (e) => {
              slideHeightAdjuster()
            }
          )
        })

        $(".testimonial-slider .row-wrap .slider-wrap").on('afterChange', function (event, slick, currentSlide) {
          $(".testimonial-slider .row-wrap .slider-wrap .card").removeClass('bg-dark-gray text-white text-black').addClass('bg-dark-gray text-white');
          $(".testimonial-slider .row-wrap .slider-wrap .card").eq(currentSlide).addClass('bg-dark-gray text-black');
        });
      }
    }

    function updateArrowTop() {
      var testimonialSliderHeight = $('.testimonial-slider .content-wrap').outerHeight();
      $('.testimonial-slider .slick-arrow').css('top', -testimonialSliderHeight + 'px');
    }
    $(window).on('load resize', function() {
      updateArrowTop();
    });

  });
})(jQuery);